import { Select } from "antd"
import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { TreeSelect } from 'antd'

// Constant
import { TEMPLATE } from '../../../../constants'

// Handlers
// import { geofences_handler } from '../../../../handlers'

// Styles
import '../../index.css'

const {
    TreeNode,
    SHOW_PARENT
} = TreeSelect;

const {
    REPORT
} = TEMPLATE

// const {
//     vehicleECUValidator
// } = geofences_handler


const DEFAULT_FILTER = REPORT.VEHICLE_REPORT_DEFAULT_FILTER;


const SearchAdvanced = (props) => {
    const {
        selectedVehicle,
        setGEOIDS = () => {},
        setDurations = () => {}
    } = props

    const duration = [ 
        { label: DEFAULT_FILTER, value: DEFAULT_FILTER},
        { label: '> 1 Min', value: 60000},
        { label: '> 2 Min', value: 120000},
        { label: '> 5 Min', value: 300000},
        { label: '> 10 Min', value: 600000},
        { label: '> 15 Min', value: 900000},
        { label: '> 30 Min', value: 1800000}
    ]

    const geofences = useSelector(state => state.containers.v3.geofences.byID)

    useEffect(() => setGEOIDS(Object.keys(geofences)), [geofences])

    return (
        <div style={{ backgroundColor: '#fff', marginTop: '20px', padding: '20px 10px'}}>
            <h3 className="formFieldLabel">Advanced Filters</h3>
            <div className = "formField">
                <span className = "formFieldLabel">Duration: </span>

                <Select
                    defaultValue={'All'}
                    style = {{ width: 200 }}
                    onChange = { currDur => setDurations(currDur)}
                >
                    {
                        duration.map((dur) =>
                            <Select.Option key = {dur.value} value = {dur.value}>
                                {dur.label}
                            </Select.Option>
                        )
                    }
                </Select>
                <span className = "formFieldLabel">Geofences: </span>

                <TreeSelect
                    allowClear
                    treeCheckable
                    showCheckedStrategy = {SHOW_PARENT}
                    placeholder = {Object.keys(geofences).length ? 'Select Geofences' : "No Geofence Found"}
                    disabled = {!Object.keys(geofences).length}
                    value = {selectedVehicle}
                    defaultValue = {DEFAULT_FILTER}
                    style = {{ width: 175 }}
                    onChange = {value => {
                        // const submitedValue = 
                        //     !value.includes(DEFAULT_FILTER) ?
                        //         (
                        //             value.map(v => convertVehicle2VID(v))
                        //         )
                        //     :
                        //         Object.values(geofences)
                        //             .filter((currVehicle) => currVehicle.name)
                        //             .sort((a, b) => {
                        //                 const vA = a.name && a.name.toLowerCase();
                        //                 const vB = b.name && b.name.toLowerCase();
                                
                        //                 if (vA < vB) return -1;
                        //                 if (vA > vB) return 1;
                        //                 return 0;
                        //             })
                        //             .map((currVehicle) => currVehicle.geoid)

                        const submitedValue = value.includes(DEFAULT_FILTER) ? Object.keys(geofences) : value

                        setGEOIDS(submitedValue)

                    }}
                >
                    {
                        <TreeNode
                            key = {DEFAULT_FILTER}
                            value = {DEFAULT_FILTER}
                            title = {"All Geofences"}
                        >
                            {
                                Object.values(geofences)
                                .filter((currGeofence) => currGeofence.name)
                                .sort((a, b) => {
                                    const vA = a.name && a.name.toLowerCase();
                                    const vB = b.name && b.name.toLowerCase();
                            
                                    if (vA < vB) return -1;
                                    if (vA > vB) return 1;
                                    return 0;
                                })
                                .map((currGeofence) => 
                                    <TreeNode
                                        key = {currGeofence.geoid}
                                        value = {currGeofence.geoid}
                                        title = {currGeofence.name}
                                        // title = {render(currVehicle.name, vehicleECUValidator(vehicleStates[currVehicle.geoid]))}
                                    />
                                )
                            }
                        </TreeNode>
                    }
                </TreeSelect>
            </div>



            <div className = "formField">
            </div>
        </div>
    )
}

export default SearchAdvanced